export const SMS_SIMULATOR_STYLES = {
  heading: "text-2xl leading-[30px] font-bold text-navy-800",
} as const;
